import { CSSProperties } from "react"

export function MicrosoftIcon({ className, style }: { className?: string; style?: CSSProperties }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className={className} style={style}>
            <path d="M0 0h48v48H0z" fill="#F25022"/>
            <path d="M52 0h48v48H52z" fill="#7FBA00"/>
            <path d="M0 52h48v48H0z" fill="#00A4EF"/>
            <path d="M52 52h48v48H52z" fill="#FFB900"/>
        </svg>
    )
}